import * as React from "react"
import gsap from "gsap"; // <-- import GSAP
import { useGSAP } from "@gsap/react"; // <-- import the hook from our React package

import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);


export default function () {
  useGSAP(() => {
    gsap.timeline({
      defaults: {
        duration: 0.2,
		delay: 3,
        ease: 'power1.inOut',
      },
      scrollTrigger: {
        trigger: "#icon-phone",
        start: "top center",
        end: "bottom center",
        markers: false,
        toggleActions: "play none play reset"
      }
    }).to('.phone-icon', {
			duration: .05,
			x: "+=6",
			repeat: 5,
  	})
	});

 return (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 87.7 97.97" id="icon-phone">
		<g fill="none" stroke="#001e5d" strokeLinejoin="round">
			<path className="phone-icon" strokeLinecap="round" strokeWidth="4" d="M2.44 39.76c-.88 3.92-.34 8.05.76 11.89 2.9 10.05 9.5 18.97 16.82 26.3 7.33 7.32 16.25 13.92 26.3 16.82 3.84 1.11 7.96 1.64 11.89.76 3.82-.86 6.46-3.07 9.18-5.73 2.11-2.13 2.16-5.53.1-7.6L57.12 71.83c-2.07-2.06-5.47-2.01-7.59.11l-5.07 5.07s-6.27-2.08-13.85-9.66-9.66-13.85-9.66-13.85l5.07-5.07c2.12-2.12 2.17-5.52.11-7.59L15.76 30.47c-2.07-2.06-5.47-2.01-7.6.1-2.66 2.72-4.87 5.36-5.73 9.18h.01ZM47.6 74.3l17.73 16.36M6.8 32.84l16.67 17.25"/>
			<g strokeWidth="4">
				<circle cx="48.37" cy="9.93" r="7.93"/>
				<path strokeLinecap="round" d="M64.24 31.84c0-2.48-1.59-6.69-3.95-7.48l-4.71-1.57L48.37 30l-7.21-7.21-4.71 1.57c-2.36.79-3.95 4.99-3.95 7.48"/>
			</g>
			<path strokeLinecap="round" strokeWidth="4.6" d="M69.69 18.07s34.67 19.89 1.01 47.31"/>
			<path strokeLinecap="round" strokeWidth="4" d="M68.91 56.22 67.49 67.3l12.88-1.42"/>
		</g>
	</svg>
 );
}